import { render, staticRenderFns } from "./LawSecurityDepositTypeForm.vue?vue&type=template&id=76400d24&"
import script from "./LawSecurityDepositTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawSecurityDepositTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawSecurityDepositTypeForm.vue?vue&type=style&index=0&id=76400d24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports